<template>
  <div class="review-progress-panel">
    <div class="grey lighten-4 px-4 py-2">
      <progress-bar
        :value="progress"
        :color="color"
        :tooltip="error"
        label="Reviewed"
      >
        <template #append>
          <div
            class="grey--text text--darken-2 font-weight-bold text-no-wrap"
          >
            {{ reviewed }} / {{ total }}
          </div>
        </template>
      </progress-bar>
    </div>
  </div>
</template>

<script>
import ProgressBar from '@/components/Common/ProgressBar';

export default {
  name: 'ReviewProgressPanel',
  components: { ProgressBar },
  props: {
    reviewed: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
    error: {
      type: String,
      default: null,
    },
  },
  computed: {
    progress() {
      return (this.reviewed / this.total) * 100;
    },
    color() {
      return this.hasError ? 'error' : 'blue lighten-2';
    },
    hasError() {
      return !!this.error;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';
.review-progress-panel {
  border-top: 1px solid map-get($grey, 'lighten-2') !important;
}
</style>
